import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import { FormattedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import { RouterLink } from "@irati/ui/src/Link";
import { ADMIN_HOME, SETTINGS_BASE } from "@irati-web/admin/src/routes/routeConfig";
import { ADMIN_TOUR_PREFIX } from "@irati-web/admin/tour";
var idNamespace = "secondaryNav";
var getReportingLink = function (hasReportingV3, path) {
    return hasReportingV3 ? (React.createElement(RouterLink, { id: id("reporting-v3", idNamespace), to: "/reporting-v3", className: path === "reporting-v3" ? "active" : "", plain: true },
        React.createElement(FormattedMessage, { id: "admin.components.mobile.header.link.reporting" }))) : (React.createElement(RouterLink, { id: id("reporting-v2", idNamespace), to: "/reporting-v2", className: path === "reporting-v2" ? "active" : "", plain: true },
        React.createElement(FormattedMessage, { id: "admin.components.mobile.header.link.reporting" })));
};
var AdminSecondaryNavLinks = function (_a, _b) {
    var pathname = _a.pathname, auth = _a.auth;
    var apps = _b.apps;
    var propApps = auth.productPermissions;
    var people = get(propApps, "admin.people");
    var teams = get(propApps, "admin.teams");
    var tenant = get(propApps, "admin.tenant");
    var reportingV3 = get(propApps, "admin.reportingV3");
    var pathArr = pathname.split("/");
    var path = pathArr[2];
    var showReportingTab = !!propApps.perks && get(propApps, "admin.reporting");
    if (!propApps.admin) {
        return (React.createElement(RouterLink, { id: id("home", idNamespace), app: apps.PLATFORM, to: ADMIN_HOME },
            React.createElement(FormattedMessage, { id: "admin.components.mobile.header.link.home" })));
    }
    // @todo: remove once multi-region tenants leaves beta
    var allowHRAdminToManageProducts = false;
    return (React.createElement("div", { "data-tour": ADMIN_TOUR_PREFIX + "-step05" },
        React.createElement(RouterLink, { plain: true, id: id("link-home", idNamespace), to: ADMIN_HOME, className: path === "home" ? "active" : "" },
            React.createElement(FormattedMessage, { id: "admin.components.mobile.header.link.home" })),
        people && (React.createElement(RouterLink, { plain: true, id: id("link-people", idNamespace), to: "/people", className: path === "people" ? "active" : "" },
            React.createElement(FormattedMessage, { id: "admin.components.mobile.header.link.people" }))),
        teams && (React.createElement(React.Fragment, null,
            React.createElement(RouterLink, { plain: true, id: id("link-teams", idNamespace), to: "/teams", className: path === "teams" ? "active" : "" },
                React.createElement(FormattedMessage, { id: "admin.components.mobile.header.link.teams" })),
            allowHRAdminToManageProducts && (React.createElement(RouterLink, { plain: true, id: id("link-products", idNamespace), to: "/products", className: path === "products" ? "active" : "" },
                React.createElement(FormattedMessage, { id: "admin.components.mobile.header.link.products" }))))),
        tenant && (React.createElement(RouterLink, { plain: true, id: id("link-settings", idNamespace), to: SETTINGS_BASE, className: path === "settings" ? "active" : "" },
            React.createElement(FormattedMessage, { id: "admin.components.mobile.header.link.settings" }))),
        showReportingTab && getReportingLink(reportingV3, path),
        React.createElement(RouterLink, { plain: true, id: id("link-help", idNamespace), to: "/help", className: path === "help" ? "active" : "" },
            React.createElement(FormattedMessage, { id: "admin.components.mobile.header.link.help" }))));
};
AdminSecondaryNavLinks.contextTypes = {
    apps: PropTypes.object
};
export default withAuth(AdminSecondaryNavLinks);
